import * as React from 'react'

const SvgCameraIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.125 16.25H1.875a.625.625 0 01-.625-.625V5c0-.345.28-.625.625-.625h4.037l1.07-1.594A.625.625 0 017.5 2.5h5c.21.001.404.107.519.281l1.069 1.594h4.037c.345 0 .625.28.625.625v10.625c0 .345-.28.625-.625.625zM2.5 15h15V5.625h-3.75a.625.625 0 01-.519-.281L12.162 3.75H7.837L6.77 5.344a.625.625 0 01-.519.281H2.5V15zm7.5-1.25a3.75 3.75 0 110-7.5 3.75 3.75 0 010 7.5zm0-6.25a2.5 2.5 0 100 5 2.5 2.5 0 000-5z"
      fill="#163250"
    />
  </svg>
)

export default SvgCameraIcon
